/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LinkMetadata } from './LinkMetadata';
import {
    LinkMetadataFromJSON,
    LinkMetadataFromJSONTyped,
    LinkMetadataToJSON,
} from './LinkMetadata';

/**
 * 
 * @export
 * @interface LinkListSectionGenerated
 */
export interface LinkListSectionGenerated {
    /**
     * 
     * @type {Array<LinkMetadata>}
     * @memberof LinkListSectionGenerated
     */
    linksMetadata: Array<LinkMetadata>;
    /**
     * 
     * @type {string}
     * @memberof LinkListSectionGenerated
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkListSectionGenerated
     */
    description?: string;
}

/**
 * Check if a given object implements the LinkListSectionGenerated interface.
 */
export function instanceOfLinkListSectionGenerated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "linksMetadata" in value;

    return isInstance;
}

export function LinkListSectionGeneratedFromJSON(json: any): LinkListSectionGenerated {
    return LinkListSectionGeneratedFromJSONTyped(json, false);
}

export function LinkListSectionGeneratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkListSectionGenerated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'linksMetadata': ((json['links_metadata'] as Array<any>).map(LinkMetadataFromJSON)),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function LinkListSectionGeneratedToJSON(value?: LinkListSectionGenerated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'links_metadata': ((value.linksMetadata as Array<any>).map(LinkMetadataToJSON)),
        'title': value.title,
        'description': value.description,
    };
}

